/*
 * Copyright (c) 2021, salesforce.com, inc.
 * SPDX-License-Identifier: BSD-3-Clause
 *
 * Category PLP page header (breadcrumb + title). Search uses `search-page-header.jsx`.
 */
import React from 'react';
import PropTypes from 'prop-types';

import Breadcrumb from '@salesforce/retail-react-app/app/components/breadcrumb';
import {
  Box,
  Fade,
  Flex,
  Heading,
} from '@salesforce/retail-react-app/app/components/shared/ui';

const PageHeader = ({
  category,
  productSearchResult,
  isLoading,
  ...otherProps
}) => (
  <Box {...otherProps} data-testid="sf-product-list-breadcrumb">
    {category && <Breadcrumb categories={category.parentCategoryTree} />}
    <Flex>
      <Heading as="h2" marginRight={2} size="lg">
        {`${category?.name || ''}`}
      </Heading>
      <Heading as="h2" marginRight={2} size="lg">
        {!isLoading && <Fade in={true}>({productSearchResult?.total})</Fade>}
      </Heading>
    </Flex>
  </Box>
);

PageHeader.propTypes = {
  category: PropTypes.object,
  isLoading: PropTypes.bool,
  productSearchResult: PropTypes.object,
};

export default PageHeader;
